import { makeStyles } from "@material-ui/core/styles";
import ClientDialog from '../Dialogs/ClientDialog';
import { useState, useContext } from 'react';
import { LabSetUpTabContext } from '../Contexts/LabSetUpTabs/LabSetUpTabContext';
import { deleteClient, getClients } from '../../services/ClientsService';
import { useTranslation } from 'react-i18next';
import GenericTable from '../GenericTable';
import { AlertContext } from '../Contexts/AlertContext/AlertContext';
import { Tooltip, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tooltipText: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
}));

function Clients(props) {
  const { text } = props;
  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const classes = useStyles();
  const [dense, setDense] = useContext(LabSetUpTabContext);
  const [alertContext, setAlertContext] = useContext(AlertContext);

    // (<Tooltip title={row.name}><Typography className={classes.tooltipText}>{}</Typography></Tooltip>)
  const columns = [
    { selector: (row) => row.name, sortable: true, name: t("client_name_field_label"), type: "text", key: "name" },
    { selector: (row) => row.description, sortable: true, name: t("description_field_label"), type: "text", key: "description" },
    { selector: (row) => row.contact, sortable: true, name: t("contact_label"), type: "text", key: "contact" },
    { selector: (row) => row.email, sortable: true, name: t("email_label"), type: "text", key: "email" },
    { selector: (row) => row.phone, sortable: true, name: t("phone_label"), type: "text", key: "phone" },
    { selector: (row) => row.clientId, sortable: true, name: t("client_id_field_label"), type: "text", key: "clientId" },
  ];

  const updateTable = async callback => {
    let data = await getClients();

    if(!(data instanceof Array)){
      setAlertContext({...alertContext, open: true});
      return;
    }
    
    setRows(data);
    callback();
  }

//  const handleDelete = async (selected) => {
//	if (window.confirm('Are you sure you wish to delete ?'))
//	{
//    for (var id in selected) {
//      await deleteClient(selected[id].id);
//    }
//}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
//  }
    const handleDelete = async (selected) => {
        if (window.confirm('Are you sure you wish to delete ?')) {
            let ids = selected.map((item) => { return item.id })
            let promises = ids.map((id) => { return deleteClient(id) })
            await Promise.all(promises)
        }
    }

  return <GenericTable
    dense={dense}
    keyColumn={{
      key: "name",
      name: t("client_name_field_label")
    }}
    setDense={setDense}
    updateTable={updateTable}
    Dialog={ClientDialog}
    rows={rows}
    columns={columns}
    text={text}
    deleteCallback={handleDelete} />;
}

export default Clients;
